import React from 'react'
import { observer } from 'mobx-react'
import { format } from 'd3-format'
import { translate } from 'utils'

const YAxisTick = ({ tick, yScale, width, height }) => (
  <g
    className='tick' opacity='1'
    key={tick}
    transform={translate(0, height - yScale(tick))}
  >
    <line x2={width} />
    <text dx='-2' dy='4'>{format(',.0f')(tick)}</text>
  </g>
)

export default observer(YAxisTick)
